module.exports = __webpack_public_path__ + "static/media/bac_logo.c73d3afe.svg";